import React from 'react';
import { VoucherFormSection } from '../../Section';

import { MinimumTicketsAmount } from '../MinimumTicketsAmount';
import { MinimumValue } from '../MinimumValue';
import { DirectRide } from '../DirectRide';

interface VoucherFormTripsProps {
  template?: {
    hideMinimumTicketsAmount: boolean;
    hideMinimumValue: boolean;
  };
}

const VoucherFormTrips: React.FC<VoucherFormTripsProps> = ({ template }) => {
  return (
    <VoucherFormSection
      title='Trips'
      subtitle='For which trips the voucher can be used.'
      inputs={
        <>
          {!template?.hideMinimumTicketsAmount && <MinimumTicketsAmount />}
          {!template?.hideMinimumTicketsAmount && <MinimumValue />}
          <DirectRide />
        </>
      }
    />
  );
};

export default VoucherFormTrips;
